export default {
    computed: {
       bannerBoosts() {return this.$store.getters.getCurrentBannerBoosts }
    }
}